import { useRef } from 'react';
import { useHistory } from 'react-router';

const useCustomRouter = () => {
  const history = useHistory();

  // const [unblock, setUnblock] = useState(null);
  const unblock = useRef(null);
  const goTo =
    (path, method = 'push') =>
    () => {
      history[method](path);
    };

  const cancelBack = (props) => {
    console.log('TEST: ', props);
    unblock.current = history.block(props);
    // setUnblock(unregister);
    return unblock.current;
  };

  const getFullPath = () => {
    return `${history.location.pathname}${history.location.search}`;
  };

  return { ...history, goTo, unblock, cancelBack, getFullPath };
};

export default useCustomRouter;
